import PropTypes from 'prop-types';
import React, { Component } from 'react';
import isEqual from 'lodash/isEqual';

import { Comment } from '../Comment';

import { CommentsContainer } from './CommentsContainer';
import { getComments } from './utils';

export class CommentsList extends Component {
	static propTypes = {
		/**
		 * The content id that the comment belongs to
		 */
		contentId: PropTypes.string.isRequired,
		/**
		 * Content Type of the page
		 */
		contentType: PropTypes.oneOf(['blogpost', 'page']),
		/**
		 * Can current user view profiles of not
		 */
		canViewProfile: PropTypes.bool,
		/**
		 * Array of comments (Immutable List)
		 */
		comments: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		/**
		 * Should we show `AUTHOR` label or not
		 */
		showAuthorLabel: PropTypes.bool,
		/**
		 * Editor properties
		 */
		/**
		 * Custom editor save handler
		 */
		editorSaveHandler: PropTypes.func,
		/**
		 * Custom editor cancel handler
		 */
		editorCancelHandler: PropTypes.func,
		/**
		 * Object with actions for comment
		 */
		commentActions: PropTypes.object,
		/**
		 * Callback function when editor has been loaded
		 */
		onEditorLoaded: PropTypes.func,
		/**
		 * The editor state object
		 */
		editor: PropTypes.object,
		/**
		 * SpaceId of current space
		 */
		spaceId: PropTypes.string.isRequired,
		/**
		 * Add/Reply comment Permission
		 */
		canReplyToComment: PropTypes.bool.isRequired,
		/**
		 * Injected ExperienceTracker object
		 */
		experienceTracker: PropTypes.object.isRequired,
		/**
		 * A feature flag to control aborting add-page-comment more aggressively to see how it affects SLA
		 */
		useNewExperienceAbort: PropTypes.bool,
		onRendered: PropTypes.func,
	};

	static defaultProps = {
		onEditorLoaded: () => {},
	};

	shouldComponentUpdate(nextProps) {
		return !isEqual(this.props, nextProps);
	}

	render() {
		const {
			contentType,
			editor,
			canViewProfile,
			contentId,
			editorSaveHandler,
			editorCancelHandler,
			comments,
			commentActions,
			showAuthorLabel,
			onEditorLoaded,
			spaceId,
			canReplyToComment,
			experienceTracker,
			useNewExperienceAbort,
			onRendered,
		} = this.props;

		const genericProps = {
			contentId,
			contentType,
			commentActions,
			canViewProfile,
			showAuthorLabel,
			editor,
			editorSaveHandler,
			editorCancelHandler,
			onEditorLoaded,
			spaceId,
			canReplyToComment,
			experienceTracker,
			useNewExperienceAbort,
			onRendered,
		};

		const elements = getComments(comments, this.props, genericProps, Comment);

		return (
			<CommentsContainer
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className="comment-threads top-level"
				id="page-comments"
				data-testid="page-comments"
			>
				{elements}
			</CommentsContainer>
		);
	}
}
